import React, { useRef, useEffect, useState } from 'react';
import cytoscape from 'cytoscape';
import cola from 'cytoscape-cola';

// Register the Cola layout plugin properly
cytoscape.use(cola);

export default function EdgeBundlingDemo() {
    const cyContainer = useRef(null);
    const [bundling, setBundling] = useState(1);
    const cyInstance = useRef(null);

    useEffect(() => {
        // generate sine-wave distances for segments
        const segmentCount = 20;
        const amplitude = 60;
        const origDists = Array.from({ length: segmentCount }, (_, i) => {
            const t = i / (segmentCount - 1); // from 0 to 1
            return amplitude * Math.sin(Math.PI * t);
        });
        const origWeights = Array(segmentCount).fill(1);
        const straightDists = Array(segmentCount).fill(0);
        const straightWeights = Array(segmentCount).fill(1);

        // initialize Cytoscape with Cola layout
        cyInstance.current = cytoscape({
            container: cyContainer.current,
            elements: {
                nodes: [
                    { data: { id: 'a' } },
                    { data: { id: 'b' } }
                ],
                edges: [
                    {
                        data: {
                            id: 'ab',
                            source: 'a',
                            target: 'b',
                            origDists,
                            origWeights,
                            straightDists,
                            straightWeights,
                            dists: origDists,
                            weights: origWeights
                        }
                    }
                ]
            },
            style: [
                {
                    selector: 'node',
                    style: {
                        'background-color': '#0074D9',
                        'label': 'data(id)'
                    }
                },
                {
                    selector: 'edge',
                    style: {
                        'curve-style': 'segments',
                        'segment-distances': 'data(dists)',
                        'segment-weights': 'data(weights)',
                        'width': 3
                    }
                }
            ],
            layout: {
                name: 'cola',
                animate: true,
                nodeSpacing: 50,
                edgeLengthVal: 100
            }
        });

        return () => cyInstance.current && cyInstance.current.destroy();
    }, []);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ marginBottom: '1em' }}>
                <label>
                    Bundling: {bundling.toFixed(2)}
                    <input
                        type="range"
                        min="0"
                        max="1"
                        step="0.01"
                        value={bundling}
                        onChange={e => setBundling(parseFloat(e.target.value))}
                        style={{ marginLeft: '0.5em' }}
                    />
                </label>
            </div>
            <div
                ref={cyContainer}
                style={{ width: '500px', height: '400px', border: '1px solid #ccc' }}
            />
        </div>
    );
}
